<template>
  <v-container class="textContent">
    <v-row>
      <v-col>
        <v-container>
          <v-row justify="center" align="center">
            <v-col lg="12" sm="12" md="12">
              <div class="d-flex justify-center align-center">
                <div style="width:15%;">
                  <label :for="$route.name + '_keyword'">關鍵字</label>
                </div>
                <v-text-field
                  :id="$route.name + '_keyword'"
                  dense
                  ref="keyword"
                  placeholder="關鍵字"
                  outlined
                  hide-details
                  v-model="Search.keyword"
                ></v-text-field>
              </div>
            </v-col>
            <v-col lg="3" sm="12" md="12">
              <div class="d-flex justify-space-center align-center">
                <div style="width:18%;margin-right:2%">
                  <label :for="$route.name + '_category'">分類</label>
                </div>
                <div style="width:80%">
                  <v-select
                    :id="$route.name + '_category'"
                    item-text="CodeDes"
                    item-value="Sno"
                    dense
                    placeholder="分類"
                    v-model="Search.category"
                    outlined
                    hide-details
                    :items="codeList"
                    role="combobox"
                    aria-haspopup="listbox"
                    tabindex="0"
                  ></v-select>
                </div>
              </div>
            </v-col>
            <v-col lg="4" sm="12" md="7">
              <div class="d-flex justify-center align-center">
                <div style="width:30%;">
                  <label :for="$route.name + '_startDate'">公告日期</label>
                </div>
                <div style="width:70%;text-align:center">
                  <!-- <DatePicker
                    :id="$route.name + '_startDate'"
                    v-model="Search.onlineDateStart"
                    placeholder="起"
                  /> -->
                  <input
                    :id="$route.name + '_startDate'"
                    type="date"
                    class="innerShadow"
                    style="width:100%;"
                    v-model="Search.onlineDateStart"
                    placeholder="起"
                  />
                </div>
                <div style="width:10%;text-align:center">
                  <label :for="$route.name + '_endDate'">至</label>
                </div>
              </div>
            </v-col>
            <v-col lg="3" sm="12" md="5">
              <div class="d-flex justify-center align-center">
                <div style="width:100%;text-align:center">
                  <!-- <DatePicker
                    :id="$route.name + '_endDate'"
                    v-model="Search.onlineDateEnd"
                    placeholder="迄"
                  /> -->
                  <input
                    :id="$route.name + '_endDate'"
                    type="date"
                    class="innerShadow"
                    style="width:100%;"
                    v-model="Search.onlineDateEnd"
                    placeholder="迄"
                  />
                </div>
              </div>
            </v-col>
            <v-col lg="2" sm="12" md="12">
              <div
                class="d-flex"
                :class="
                  $vuetify.breakpoint.lg
                    ? 'justify-space-around'
                    : 'justify-end'
                "
              >
                <v-btn
                  :color="'#FFF777'"
                  title="清除"
                  class="ct-text-bolder d-flex justify-center align-center mr-4"
                  @click="ClearSearch()"
                >
                  <span style="display:inline-block">清除</span>
                </v-btn>
                <v-btn
                  :color="'#FFF777'"
                  title="搜尋"
                  class="ct-text-bolder d-flex justify-center align-center"
                  @click="
                    SearchList();
                    SetPage();
                  "
                >
                  <span style="display:inline-block">搜尋</span>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        v-for="(item, idx) in pageList"
        :key="idx"
        role="button"
        tabindex="0"
        :title="'前往' + item.title"
        @click="
          SetPage(pagination.page);
          fn(item, (pagination.page - 1) * pagination.count + idx);
        "
        @keypress="
          SetPage(pagination.page);
          fn(item, (pagination.page - 1) * pagination.count + idx);
        "
      >
        <ListItem :item="item" />
      </v-col>
    </v-row>
    <v-row class="justify-center align-center my-12">
      <v-pagination
        v-if="pageLength > 0"
        v-model="pagination.page"
        :length="pageLength"
        next-aria-label="下一頁"
        previous-aria-label="上一頁"
        circle
        @input="
          SetPage;
          $refs.keyword.focus();
        "
      >
      </v-pagination>
    </v-row>
  </v-container>
</template>
<script>
import ListItem from "@/components/ui/searchList/ListItem.vue";
// import DatePicker from "@/components/ui/searchList/DatePicker.vue";
export default {
  components: {
    ListItem
    // DatePicker
  },
  data() {
    return {
      pagination: {
        page: 1,
        count: 10
      },
      Search: {
        keyword: "",
        category: -1,
        onlineDateStart: null,
        onlineDateEnd: null
      },
      filterList: []
    };
  },
  computed: {
    pageLength() {
      return Math.ceil(this.filterList.length / this.pagination.count);
    },
    pageList() {
      let dataCount = (this.pagination.page - 1) * this.pagination.count;
      return this.filterList.slice(
        dataCount,
        dataCount + this.pagination.count
      );
    },
    codeList() {
      let data = this.$store.state.global.codeList;
      if (this.itemList.length > 0) {
        let list = [];
        list = data.filter(p => p.CodeClass == this.itemList[0].category);
        list.splice(0, 0, {
          Sno: -1,
          CodeClass: -1,
          CodeDes: "不限"
        });
        return list;
      } else {
        return [];
      }
    }
  },

  props: {
    itemList: {
      type: Array,
      default() {
        return [];
      }
    },
    fn: {
      type: Function,
      default: function(e) {
        console.log(e);
      }
    }
  },
  methods: {
    SearchList() {
      if (this.itemList.length > 0) {
        let s = this.Search;
        this.filterList = this.itemList.filter(
          p =>
            (s.keyword == "" ||
              (typeof p.title.includes != "undefined" &&
                p.title.includes(s.keyword))) &&
            // 20211008 內容先不用
            //   ||
            // (p.content != null &&
            //   this.TOOL.setNoHTMLTag(
            //     this.TOOL.getContentStr(p.content)
            //   ).includes(s.keyword))
            (s.category == -1 || p.subcategory == s.category) &&
            (s.onlineDateStart == null ||
              s.onlineDateStart == undefined ||
              Date.parse(p.onlineDate) >=
                Date.parse(s.onlineDateStart + "T00:00:00")) &&
            (s.onlineDateEnd == null ||
              s.onlineDateEnd == undefined ||
              Date.parse(p.onlineDate) <=
                Date.parse(s.onlineDateEnd + "T23:59:59"))
        );
      }

      //20220715 新增搜尋條件暫存
      const path = this.$route.name;
      const keys = Object.keys(this.Search);
      for (const item of keys) {
        const itemName = "Search" + "." + path + "." + item;
        sessionStorage.setItem(itemName, this.Search[item]);
      }
    },
    ClearSearch() {
      this.Search = {
        keyword: "",
        category: -1,
        onlineDateStart: null,
        onlineDateEnd: null
      };
      this.SearchList();
    },
    initSearch() {
      const path = this.$route.name;
      const keys = Object.keys(this.Search);
      for (const item of keys) {
        const itemName = "Search" + "." + path + "." + item;
        const value = sessionStorage.getItem(itemName);

        if (
          value != null &&
          value != "null" &&
          value != "" &&
          value != "undefined"
        ) {
          const reV = isNaN(value) ? value : parseInt(value);
          this.Search[item] = reV;
        }
      }
    },
    SetPage(page = 1) {
      this.$vuetify.goTo(".textContent");
      // this.$refs.keyword.focus();
      const path = this.$route.name;
      const itemName = "Page" + "." + path + ".Page";
      sessionStorage.setItem(itemName, page);

      this.pagination.page = page;
    },
    initPage() {
      const path = this.$route.name;
      const itemName = "Page" + "." + path + ".Back";
      const value = sessionStorage.getItem(itemName);
      if (value == "true") {
        sessionStorage.removeItem(itemName);
        const pageName = "Page" + "." + path + ".Page";
        const page = sessionStorage.getItem(pageName);

        if (
          page != null &&
          page != "null" &&
          page != "" &&
          page != "undefined" &&
          !isNaN(page)
        ) {
          this.pagination.page = parseInt(page);
        }
      }
    },
    initCategory() {
      const category = this.$route.query.category;
      if (
        category &&
        this.codeList.findIndex(p => p.CodeDes == category) >= 0
      ) {
        this.Search.category = this.codeList.find(
          p => p.CodeDes == category
        ).Sno;
      }
    }
  },
  watch: {
    itemList() {
      this.filterList = this.itemList;
      this.SearchList();
    },
    "$route.query"() {
      this.$nextTick(() => {
        this.initCategory();
        this.SearchList();
      });
    },
    "codeList.length"() {
      this.initCategory();
      this.SearchList();
    }
  },
  mounted() {
    this.filterList = this.itemList;

    this.initPage();

    this.initSearch();
    this.SearchList();
  }
};
</script>
<style lang="scss" scoped>
.v-input {
  background-color: #fcfcfc;
}

input[type="date"] {
  padding: 0 0.5rem 0 0.5rem;
  min-height: 40px;
  border: 1px solid rgba(0, 0, 0, 0.42);
  border-radius: 4px;
  transition: border 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  background-color: white;
}
input[type="date"]:focus {
  outline: none !important;
  border: 2px solid #62922a;
}
</style>
